<video #player class="joymo-video-player video-js" playsinline></video>
